import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center gap-2 w-100" }
const _hoisted_2 = { class: "ms-2" }
const _hoisted_3 = { class: "ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createBlock(_component_BaseModal, {
    "is-display": _ctx.isDisplay,
    title: _ctx.title,
    size: _ctx.size,
    width: _ctx.width,
    "backdrop-z-index": 3050,
    "modal-z-index": 3060,
    "is-close-disabled": _ctx.isConfirming,
    "close-on-backdrop-click": false,
    "close-on-escape": !_ctx.isConfirming,
    onClose: _ctx.onClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ButtonCustom, {
          "data-autofocus": "",
          "color-type": _ctx.ButtonTypeColors.PRIMARY,
          "button-type": _ctx.ButtonsType.REGULAR_QUESTION,
          "is-disabled": _ctx.isConfirming,
          "is-loading": _ctx.isConfirming,
          onClick: _ctx.onConfirm
        }, {
          "button-label": _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.confirmText), 1)
          ]),
          _: 1
        }, 8, ["color-type", "button-type", "is-disabled", "is-loading", "onClick"]),
        _createVNode(_component_ButtonCustom, {
          "color-type": _ctx.ButtonTypeColors.DANGER,
          "button-type": _ctx.ButtonsType.CANCEL,
          "is-disabled": _ctx.isConfirming,
          onClick: _ctx.onClose
        }, {
          "button-label": _withCtx(() => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.cancelText), 1)
          ]),
          _: 1
        }, 8, ["color-type", "button-type", "is-disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["is-display", "title", "size", "width", "is-close-disabled", "close-on-escape", "onClose"]))
}